module.exports = __webpack_public_path__ + "img/phox2.fcddcdc7.png";